import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextColor } from '../../Atoms/Text';
import DropdownMenu, { MenuOption } from '../Menu/DropdownMenu';
import { IconType } from '../../Atoms/Icon';
import { getUserSubject, User, UserRole, hasEngineerOrHigherPermissions } from '../../../store/User';
import { CommissionPopover } from '../CommissionPopover/CommissionPopover';
import { SearchBox } from '../Search/Search';
import { useAuth } from '../../../Context/AuthContext';

export const NavBar = () => {
  const { signOut, authState, token } = useAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState<User>();

  useEffect(() => {
    const userSub = getUserSubject().subscribe((u) => setUser(u));

    return () => {
      if (userSub) userSub.unsubscribe();
    };
  }, []);

  const settingsOption: MenuOption = {
    title: 'Settings',
    onClick: () => navigate('/settings'),
    fontColor: 'grey6' as TextColor,
    icon: 'settings' as IconType
  };

  const menuOptions: MenuOption[] = [
    ...(hasEngineerOrHigherPermissions() ? [settingsOption] : []),
    {
      title: 'Log Out',
      onClick: async () => {
        await signOut();
      },
      fontColor: 'grey6' as TextColor,
      icon: 'logoutSmall' as IconType
    }
  ];

  return (
    <Fragment>
      {authState?.isAuthenticated && token && user?.role !== UserRole.INACTIVE ? (
        <div
          data-testid="nav-bar-container"
          className="flex w-full items-center py-4 px-3 border-gray-200 bg-white border-b">
          <div className="flex ml-3 mr-auto justify-start space-x-3 items-center">
            <SearchBox showAllResultsLink />
            <CommissionPopover />
          </div>
          <div className="flex ml-auto justify-end space-x-3 items-center">
            {user && (
              <DropdownMenu
                icon="account"
                buttonText={`${user?.firstName} ${user?.lastName}`}
                options={menuOptions}
                slotProps={{
                  paper: {
                    style: {
                      width: 150
                    }
                  }
                }}
              />
            )}
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </Fragment>
  );
};
